export default "__VITE_ASSET__762148ae__"